module.exports = __webpack_public_path__ + "img/taxe.87c4efbb.png";